import { mappingIcon } from './mapping.es.js';
export { Icon } from './base-components/IconBase.es.js';

const LIST_ICONS = Object.keys(mappingIcon);

export { LIST_ICONS };
